import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'

import { routes } from './paths'
import { handleChunkLoadError } from '@/utils/build'

const router = createRouter({
  history: import.meta.env.MODE === 'test' ? createMemoryHistory() : createWebHistory(),
  routes,
  scrollBehavior () {
    return { left: 0, top: 0 }
  },
})

router.onError((err) => {
  handleChunkLoadError(err)
})

export default router
